<script setup>
import {useSystem} from "../../store/system"
import {onMounted, ref, watch} from "vue";
import {useRouter} from "vue-router";

const systemStore = useSystem()
const router = useRouter()

const activeMenu = ref("/Dashboard")
if (window.location.pathname.length > 0 && window.location.pathname != '/') {
  activeMenu.value = window.location.pathname
}

const handleOpen = (key, keyPath) => {
  // console.log('handleOpen', key, keyPath)
}
const handleClose = (key, keyPath) => {
  // console.log('handleClose', key, keyPath)
}
const handleSelect = (key, keyPath) => {
  console.log('handleSelect', key, keyPath)
  if (key == "/logout"){
    systemStore.logoutApi(router)
  }else{
    activeMenu.value = key
  }
}


//监听是否点击了菜单(手机模式)
const drawer = ref(false)

watch(() => systemStore.isOpenMenu, (newValue, oldValue) => {
  drawer.value = newValue
})
const closeDrawer = (done) => {
  let headerBtn = document.querySelector('.header__btn');
  headerBtn.classList.toggle('header__btn--active');
  done()
  systemStore.setMenuIsOpen(false)
}

const drawBox = ref("body")
// onMounted(() => {
//   drawBox.value = ".draw-box"
// })


</script>

<template>
  <el-row class="tac" v-if="!systemStore.getIsMobile">
    <el-col :span="24">
<!--      <h5 class="mb-2">Custom colors</h5>-->
      <el-menu
          active-text-color="#a034fa"
          background-color="#16142a"
          class="el-menu-vertical-demo"
          :default-active="activeMenu"
          text-color="#fff"
          @open="handleOpen"
          @close="handleClose"
          @select="handleSelect"
          :router="true"
          style="height: calc(100vh - 85px)"
      >
        <el-menu-item index="/Dashboard">
          <el-icon><Menu /></el-icon>
          <span>Dashboard</span>
        </el-menu-item>

<!--        <el-sub-menu index="2">-->
<!--          <template #title>-->
<!--            <el-icon><Shop /></el-icon>-->
<!--            <span>Finance</span>-->
<!--          </template>-->
<!--          <el-menu-item-group>-->
<!--            <el-menu-item index="/Deposit">Deposit</el-menu-item>-->
<!--            <el-menu-item index="/Withdraw">Withdraw</el-menu-item>-->
<!--            <el-menu-item index="/Transactions">Transactions</el-menu-item>-->
<!--          </el-menu-item-group>-->
<!--        </el-sub-menu>-->

        <el-menu-item index="/Deposit">
          <el-icon><Sort /></el-icon>
          <span>Deposit</span>
        </el-menu-item>

        <el-menu-item index="/Withdraw">
          <el-icon><Printer /></el-icon>
          <span>Withdraw</span>
        </el-menu-item>

        <el-menu-item index="/Transactions">
          <el-icon><MessageBox /></el-icon>
          <span>Transactions</span>
        </el-menu-item>

        <el-menu-item index="/Orders">
          <el-icon><List /></el-icon>
          <span>Orders</span>
        </el-menu-item>

        <el-menu-item index="/Referrals">
          <el-icon><Share /></el-icon>
          <span>Referrals</span>
        </el-menu-item>

        <el-menu-item index="/Wallets">
          <el-icon><WalletFilled /></el-icon>
          <span>Wallets</span>
        </el-menu-item>

        <el-menu-item index="/Settings">
          <el-icon><Tools /></el-icon>
          <span>Setting</span>
        </el-menu-item>

        <el-menu-item index="/Support">
          <el-icon><QuestionFilled /></el-icon>
          <span>Support</span>
        </el-menu-item>

        <el-menu-item index="/logout" class="tw-text-center tw-justify-center tw-mt-[20px] hover:!tw-bg-red-600">
          <font-awesome-icon class="tw-text-[20px]" :icon="['fas', 'arrow-right-from-bracket']" />
          <span class="tw-text-[16px] tw-font-bold tw-ml-2"> Sign out</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>

  <el-drawer
      v-if="systemStore.getIsMobile && drawBox"
      v-model="drawer"
      direction="ltr"
      size="55%"
      :before-close="closeDrawer"
      :append-to="drawBox"
      modal-class="drawer-bg"
  >
    <template #header>
<!--      <div>Logo Image</div>-->
    </template>

    <el-row class="tac">
      <el-col :span="24">
        <!--      <h5 class="mb-2">Custom colors</h5>-->
        <el-menu
            active-text-color="#a034fa"
            background-color="#16142a"
            class="el-menu-vertical-demo"
            :default-active="activeMenu"
            text-color="#fff"
            @open="handleOpen"
            @close="handleClose"
            @select="handleSelect"
            :router="true"
            style="height: calc(100vh - 120px)"
        >
          <el-menu-item index="/Dashboard">
            <el-icon><Menu /></el-icon>
            <span>Dashboard</span>
          </el-menu-item>

<!--          <el-sub-menu index="2">-->
<!--            <template #title>-->
<!--              <el-icon><Shop /></el-icon>-->
<!--              <span>Finance</span>-->
<!--            </template>-->
<!--            <el-menu-item-group>-->
<!--              <el-menu-item index="/Deposit">Deposit</el-menu-item>-->
<!--              <el-menu-item index="/Withdraw">Withdraw</el-menu-item>-->
<!--              <el-menu-item index="/Transactions">Transactions</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--          </el-sub-menu>-->

          <el-menu-item index="/Deposit">
            <el-icon><Sort /></el-icon>
            <span>Deposit</span>
          </el-menu-item>

          <el-menu-item index="/Withdraw">
            <el-icon><Printer /></el-icon>
            <span>Withdraw</span>
          </el-menu-item>

          <el-menu-item index="/Transactions">
            <el-icon><MessageBox /></el-icon>
            <span>Transactions</span>
          </el-menu-item>

          <el-menu-item index="/Orders">
            <el-icon><List /></el-icon>
            <span>Orders</span>
          </el-menu-item>

          <el-menu-item index="/Referrals">
            <el-icon><Share /></el-icon>
            <span>Referrals</span>
          </el-menu-item>

          <el-menu-item index="/Wallets">
            <el-icon><WalletFilled /></el-icon>
            <span>Wallets</span>
          </el-menu-item>

          <el-menu-item index="/Settings">
            <el-icon><Tools /></el-icon>
            <span>Setting</span>
          </el-menu-item>

          <el-menu-item index="/Support">
            <el-icon><QuestionFilled /></el-icon>
            <span>Support</span>
          </el-menu-item>

          <el-menu-item index="/logout" class="tw-text-center tw-justify-center tw-mt-[20px] hover:!tw-bg-red-600">
            <font-awesome-icon class="tw-text-[20px]" :icon="['fas', 'arrow-right-from-bracket']" />
            <span class="tw-text-[16px] tw-font-bold tw-ml-2"> Sign out</span>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </el-drawer>
</template>

<style lang="scss">
.el-menu{
  border-right: 1px solid $p-border-color !important;
}
.drawer-bg{
  &>.el-drawer{
    background: $p-color;
    color: $p-text-color;

    &>.el-drawer__header{
      color: $p-text-color;
    }
  }
}
</style>
